<template>
  <el-form
    ref="recoverPasswordForm"
    class="recoverPasswordForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <el-form-item
      :label="$t('auth.recoverPassword.form.recoverPasswordLabel')"
      prop="new_password"
    >
      <el-input
        v-model="form.new_password"
        name="new_password"
        show-password
        type="password"
        :placeholder="$t('auth.recoverPassword.form.recoverPasswordPlaceholder')"
      />
    </el-form-item>
    <el-form-item
      :label="$t('auth.recoverPassword.form.recoverPasswordConfirmationLabel')"
      prop="new_password_confirmation"
    >
      <el-input
        v-model="form.new_password_confirmation"
        name="new_password_confirmation"
        show-password
        type="password"
        :placeholder="$t('auth.recoverPassword.form.recoverPasswordConfirmationPlaceholder')"
      />
    </el-form-item>
    <el-button
      class="recoverPasswordForm__submit"
      type="primary"
      :loading="loading"
      :disabled="!form.new_password || !form.new_password_confirmation"
      @click="onSubmit"
    >{{ $t('auth.recoverPassword.form.submitButton') }}</el-button>
  </el-form>
</template>

<script>
export default {
  name: "RecoverPasswordForm",
  data() {
    return {
      loading: false,
      form: {
        new_password: null,
        new_password_confirmation: null,
      }
    }
  },
  computed: {
    rules() {
      return {
        new_password: { required: true, type: 'string', validator: this.$helpers.newPasswordValidator },
        new_password_confirmation: { required: true, type: 'string', trigger: 'blur', validator: this.$helpers.newPasswordConfirmValidator }
      }
    }
  },
  methods: {
    newPasswordConfirmValidator(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('forms.validation.invalidNewPassword')))
      } else if (value.length < 6) {
        callback(new Error(this.$t('forms.validation.passwordMinLength')))
      } else if (value !== this.form.new_password) {
        callback(new Error(this.$t('forms.validation.passwordDontMatch')))
      } else {
        callback()
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const result = await this.$refs['recoverPasswordForm'].validate()

        if (result) {
          await this.$store.dispatch('customer/resetPassword', {
            ...this.form,
            email: this.$route.query.email,
            reset_password_token: this.$route.query.token
          })
        }
        this.loading = false
        this.$notify({
          type: 'success',
          title: this.$t('base.success.notificationTitle'),
          message: this.$t('auth.recoverPassword.form.recoverPasswordNotificationSuccess')
        })
        // redirect to login form
        this.$router.push({
          name: 'login'
        })
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: ".recoverPasswordForm";

#{$c} {
  min-width: 240px;

  #{$c}__submit {
    align-self: center;
    margin-top: 56px;
    margin-bottom: 138px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>